// FileUploadPDP.ei1.ServiceFee.js
// Auto-adds a $1 "Copy Service Fee" line to the cart, one per Copy line
// item present (2 Copy jobs => fee qty 2 => $2), and removes it when no Copy
// items remain. Reuses the proven MailboxServiceFee v14 pattern:
//   - container.getComponent('Cart')
//   - reconcile() guarded by a `reconciling` flag (idempotent; only acts
//     when the fee's current state differs from desired)
//   - Cart.getLines() to read, Cart.addLine()/removeLine() to change
//   - Copy lines detected by matrix_parent.internalid === COPY_PARENT_ID
//     (robust across the 250+ matrix child SKUs - no URL guessing)
//
// NOTE: "per Copy line" means the fee quantity = the NUMBER OF COPY LINE
// ITEMS, never the Copy line's own quantity (which is pages*copies and must
// not drive the fee).
define('FileUploadPDP.ei1.ServiceFee', [
    'underscore'
], function (
    _
) {
    'use strict';

    // TODO: set to the real internal ID of the "Copy Service Fee" service
    // item once created in NetSuite ($1, taxable).
    var SERVICE_FEE_ITEM_ID = 21967;

    // Copy PARENT item id (matrix parent). Matches ENABLED_ITEM_IDS on PDP.
    var COPY_PARENT_ID = 21098;

    function init(container) {
        var Cart = container.getComponent('Cart');
        if (!Cart) {
            return;
        }
        if (!SERVICE_FEE_ITEM_ID) {
            // Not configured yet - do nothing rather than add a broken line.
            return;
        }

        var reconciling = false;

        function isCopyLine(line) {
            var parentId = line &&
                line.item &&
                line.item.extras &&
                line.item.extras.matrix_parent &&
                parseInt(line.item.extras.matrix_parent.internalid, 10);
            return parentId === COPY_PARENT_ID;
        }

        function reconcile() {
            if (reconciling) {
                return;
            }
            reconciling = true;

            Cart.getLines().then(function (lines) {
                var copyLineCount = 0;
                var feeLine = null;

                _.each(lines, function (line) {
                    var itemId = line.item && parseInt(line.item.internalid, 10);
                    if (itemId === SERVICE_FEE_ITEM_ID) {
                        feeLine = line;
                        return;
                    }
                    if (isCopyLine(line)) {
                        copyLineCount += 1; // per LINE, not per quantity
                    }
                });

                var done = function () { reconciling = false; };

                if (copyLineCount > 0) {
                    if (!feeLine) {
                        return Cart.addLine({
                            line: {
                                quantity: copyLineCount,
                                item: { internalid: SERVICE_FEE_ITEM_ID }
                            }
                        }).always(done);
                    }
                    if (Number(feeLine.quantity) !== copyLineCount) {
                        // remove-then-re-add (updateLine not reliably available)
                        return Cart.removeLine({ line_id: feeLine.internalid })
                            .then(function () {
                                return Cart.addLine({
                                    line: {
                                        quantity: copyLineCount,
                                        item: { internalid: SERVICE_FEE_ITEM_ID }
                                    }
                                });
                            }).always(done);
                    }
                    return done();
                }

                // No Copy lines - remove the fee if present.
                if (feeLine) {
                    return Cart.removeLine({ line_id: feeLine.internalid }).always(done);
                }
                return done();
            }, function () {
                reconciling = false;
            });
        }

        // Fire reconcile on every cart mutation.
        if (Cart.on) {
            Cart.on('afterAddLine', reconcile);
            Cart.on('afterRemoveLine', reconcile);
            Cart.on('afterUpdateLine', reconcile);
        }
        // Initial pass (cart may already contain Copy items on load).
        reconcile();
    }

    return { init: init };
});
